import React from 'react';
import { getLocalStorageItem } from '../../../localStorageUtils';
import { Button, Box, Typography } from '@mui/material';
import { authKey, UPLOAD_PHOTO, UPDATE_STAKEHOLDER_PHOTO } from '../../../URLs';

import { loaderService } from "../../../custom-loader/loader-service";
import { useEffect } from "react";
import { useState } from 'react';
import { FILE_NAME_VALIDATION_ERROR, allowedPhotoTypes } from '../../../constants';
import { toast } from 'react-toastify';
import { fileNameValidation } from '../../../commonValidations';
import apiClient from '../../../../axios';

function PhotoUpload(props) {

  const [selectedPhotoFile, setSelectedPhotoFile] = React.useState();
  const [photoUploadDetails, setPhotoUploadDetails] = React.useState();
  const [file, setFile] = React.useState();
  // const [updatePhoto, setUpdatePhoto] = useState([]);
  const [updatedImage, setUpdatedImage] = useState(props.updatePhoto);
  const [account, setAccount] = useState(props.accountDetails);
  const [url, setUrl] = useState();
  const [errorMessage, setErrorMessage] = useState({
    photoError: '',
  })

  const [photoDetails, setPhotoDetails] = useState({
    "id": "",
    "documentType": "",
    "documentName": "",
    "documentBlobName": "",
    "documentPath": "",
    "documentContainerName": "",
    "stakeholderType": "",
    "stakeholderDetailId": "",
    "createdOn": "",
    "createdBy": "string",
    "updatedOn": "",
    "updatedBy": "string",
    "isActive": 0
  });


  useEffect(() => {
    if (selectedPhotoFile) {
      getUploadPhotoDetails();
    }
  }, [selectedPhotoFile]);

  const uploadPhoto = (e, type) => {
    if (allowedPhotoTypes.indexOf(e.target.files[0].type) < 0) {
      return;
    }
    if (e.target.files[0].name.split('.').length > 2) {
      setErrorMessage({
        ...errorMessage,
        photoError: "Double extension file detected",
      });
      return;
    }
    if (e.target.files[0].size >= 5000000) {
      setErrorMessage({
        ...errorMessage,
        photoError: "The file should be less than 5MB",
      });
    }
    else if(fileNameValidation(e.target.files[0].name)) {
      setErrorMessage({
        ...errorMessage,
        photoError: FILE_NAME_VALIDATION_ERROR,
      });
    }
     else {
      setSelectedPhotoFile(e.target.files[0]);
      setUrl(URL.createObjectURL(e.target.files[0]))
      // setSpeciesDetails({ ...speciesDetails, photoName: e.target.files[0]?.name })
      setErrorMessage({ ...errorMessage, photoError: "" });
    }
  };

  function getUploadPhotoDetails() {
    loaderService.showLoader();
    const formData = new FormData();
    formData.append("file", selectedPhotoFile);
    formData.append("fileName", selectedPhotoFile.name);
    formData.append("containerName", "stakeholder");
    apiClient
      .post(UPLOAD_PHOTO, formData, {
        headers: {
          AuthKey: authKey,
        },
      })
      .then((response) => {
        setPhotoUploadDetails(response.data);
        // console.log(response.data)
        loaderService.hideLoader();
      })

      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader();
      });
  }


  // function handleChange(e) {
  //   console.log(e.target.files);
  //   setSelectedPhotoFile(URL.createObjectURL(e.target.files[0]));
  // }

  function updateStakeholderPhoto() {
    loaderService.showLoader();
    apiClient
      .post(UPDATE_STAKEHOLDER_PHOTO,
        {
          "urn": account?.urn,
          "photoDetails": {
            "id": "",
            "documentType": "Photo",
            "documentName": photoUploadDetails?.blobResponse?.fileName,
            "documentBlobName": photoUploadDetails?.blobResponse?.blobFileName,
            "documentPath": "",
            "documentContainerName": "stakeholder",
            "stakeholderType": account.categoryName,
            "stakeholderDetailId": "",
            "createdOn": "",
            "createdBy": "",
            "updatedOn": "",
            "updatedBy": "",
            "isActive": 0
          }
        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          }
        }, null
      )
      .then((response) => {
        setUpdatedImage(response.data);
        toast.success(response.data.message);
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log(error);
        toast.error(error.message);
        loaderService.hideLoader();
      });
  }

  const onSave = (e) => {
    updateStakeholderPhoto();
    props.onClose()
  }
  const onCancel = (e) => {
    props.onClose()
  }

  return (
     <>
        <div className="error-msg" style={{ marginBottom: "3vh" }}>
          {errorMessage.photoError}
        </div>
        <label class="chooseFile-create-rateCard">
                                    <input style={{ display: "none" }} type="file" name="transitFileName" accept="image/jpeg, image/jpg, image/png, .pdf" onChange={(e) => uploadPhoto(e)}/>Upload File
                                    <label className="documentName-create-pickupdetails">{photoUploadDetails?.blobResponse?.fileName}</label>
                                  </label>
                                  <Typography variant="subtitle2" fontSize="1.8vh" align="left" color="green">(upload only .png, .jpg, .jpeg, files.File size limit=5MB)</Typography>
        {selectedPhotoFile != null ?
          <>
            <div style={{ marginTop: "2vh" }}>
              <img style={{ width: "auto", height: "20vh" }} src={url} />
            </div>
          </>
          : null
        }
        <Box display='flex' alignItems="center" justifyContent="center" mt={3} style={{ float: "right" }}>
         <Button onClick={(e) => onCancel(e)}>Cancel</Button>
        {selectedPhotoFile != null && <Button  onClick={(e) => onSave(e)}>Save</Button> }
        </Box>
        </>
  );
};
export default PhotoUpload;